const __WEBPACK_NAMESPACE_OBJECT__ = require("plugin-liverig/shared/components/UnitsSelector");